import React from 'react';
import Icon from '@pushpay/icon';

const PencilWriteIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.712 16.386L9 16.916l.53-3.716 9.546-9.546a2.25 2.25 0 113.182 3.186z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.25 15h-3a1.5 1.5 0 00-1.5 1.5v3a1.5 1.5 0 001.5 1.5h19.5a1.5 1.5 0 001.5-1.5v-3a1.5 1.5 0 00-1.5-1.5h-3",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

export default PencilWriteIcon;